/** Small date-formatting helpers shared by the household screens. */

/**
 * Format an ISO timestamp as a short `DD/MM` date, the way the field
 * screens read a follow-up or visit date at a glance.
 *
 * @param iso - An ISO 8601 timestamp.
 * @returns The `DD/MM` date.
 */
export function formatShortDate(iso: string): string {
  return new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit' }).format(
    new Date(iso),
  );
}

/**
 * Cap free text to at most `max` characters, appending an ellipsis when it
 * was cut. Used for a failed follow-up message's raw technical error
 * (`docs/FOLLOWUP.md` §5): shown as-is, never reworded, just kept short.
 *
 * @param text - The text to cap.
 * @param max - The maximum length to keep before the ellipsis.
 * @returns `text` unchanged when short enough, otherwise its first `max`
 *   characters followed by "…".
 */
export function truncate(text: string, max: number): string {
  return text.length > max ? `${text.slice(0, max)}…` : text;
}
